// extracted by mini-css-extract-plugin
export default {"root":"RecentActivity_root__HR5cT","header":"RecentActivity_header__jO2X0"};